import script from "./StudiesClinicianList.vue?vue&type=script&setup=true&lang=js"
export * from "./StudiesClinicianList.vue?vue&type=script&setup=true&lang=js"

import "./StudiesClinicianList.vue?vue&type=style&index=0&id=4e95ef52&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e95ef52"]])

export default __exports__